const image = (url, w = 150, h, option) => {
  if (!h) h = w;
  return `//images.weserv.nl/?url=${encodeURI(url)}&w=${w}&h=${h}${imageOptions(
    option
  )}`; // https://images.weserv.nl/docs/crop.html#position-based
};

const imageOptions = option => {
  let url = "&";
  switch (option) {
    case "cover":
      url += "fit=cover&a=center";
      break;

    default:
      url += "fit=contain&cbg=white";
      break;
  }
  return url;
};

// https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/NumberFormat
const priceFormat = price => {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR"
  }).format(price);
};

const truncate = (value, length) => {
  length = length || 15;
  if (!value || typeof value !== "string") return "";
  if (value.length <= length) return value;
  return value.substring(0, length) + "...";
};

export { image, priceFormat, truncate };
